<template>
    <div>
        <el-button type="primary" @click="open">{{ $t('create_ticket') }}</el-button>

        <el-table
                v-loading="loading"
                :data="data"
                :row-class-name="tableRowClassName"
                @row-click="go"
                style="width: 100%">

            <el-table-column
                    prop="created_at"
                    :label="$t('created_at')">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i> {{ scope.row.created_at | moment("YYYY-MM-DD HH:mm") }}
                </template>
            </el-table-column>

            <el-table-column
                    :label="$t('topic')">
                <template slot-scope="scope">
                    <router-link :to="{name: 'ticket-messages', params: { id: scope.row.id }}">
                        {{ scope.row.topic }}
                    </router-link>
                </template>
            </el-table-column>

            <el-table-column
                    :label="$t('section')">
                <template slot-scope="scope">
                    {{ scope.row.section.name }}

                </template>
            </el-table-column>

            <el-table-column
                    :label="$t('last_message')">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i> {{ scope.row.updated_at | moment("YYYY-MM-DD HH:mm") }}
                </template>
            </el-table-column>

            <el-table-column
                    :label="$t('status')">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status" disable-transitions>{{ $t('ticket_statuses.open') }}</el-tag>
                    <el-tag type="info" v-if="!scope.row.status" disable-transitions>{{ $t('ticket_statuses.closed') }}</el-tag>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-count="total_pages">
            </el-pagination>
        </div>

        <el-dialog v-on:closed="formReset" :title="$t('create_ticket')" :visible.sync="dialogFormVisible">
            <el-form :model="model" status-icon label-width="140px">
                <el-form-item :label="$t('section')" prop="topic" :error="error_form.section_id">
                    <el-select v-model="model.section_id" style="width: 100%">
                        <el-option
                                v-for="item in sections"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('topic')" prop="topic" :error="error_form.topic">
                    <el-input v-model="model.topic"></el-input>
                </el-form-item>
                <el-form-item :label="$t('message')" :error="error_form.message">
                    <el-input type="textarea" v-model="model.message" :autosize="{ minRows: 4, maxRows: 10 }"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="create" :loading="loading_form">{{ $t('submit') }}</el-button>
                    <el-button @click="dialogFormVisible = false">{{ $t('cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "Ticket",
        data () {
            return {
                loading: false,
                data: [],
                page: 1,
                total_pages: 0,
                dialogFormVisible: false,
                model: {},
                loading_form: {},
                error_form: {},
                sections: []
            }
        },
        created () {
            this.fetchData();
        },
        watch: {
            '$store.getters.getTicketUnread': {
                handler () {
                    this.fetchData();
                },
                deep: true
            }
        },
        methods: {
            fetchData () {
                this.loading = true;
                this.$axios.get('/tickets?page=' + this.page).then((res) => {
                    this.loading = false;
                    this.data = res.data;
                    this.total_pages = parseInt(res.headers['x-pagination-page-count']);
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.fetchData()
            },
            tableRowClassName({row}) {
                if (!row.member_read) {
                    return 'success-row font-bold-row';
                }
                return '';
            },
            formReset () {
                this.model = {};
                this.error_form = {};
                this.loading_form = false;
            },
            create () {
                this.loading_form=true;
                this.$axios.post('/tickets', this.model).then(() => {
                    this.error_form = {};
                    this.loading_form = false;
                    this.dialogFormVisible=false;
                    this.fetchData()
                }).catch((error) => {
                    if (error.response.status === 422) {
                        this.error_form = error.response.data;
                    }

                    this.loading_form=false;
                });
            },
            open () {
                this.dialogFormVisible=true;
                this.formReset();
                this.$axios.get('/tickets/sections').then((res) => {
                    this.sections = res.data;
                })
            },
            go (model) {
                //this.$router.push({name: 'ticket-messages', params: { id: model.id }})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .el-table {
        margin-top: 15px;


    }

</style>